// Role of this file:
// Listen for an action
// produce a side effect which is communicate with the server via http,
// bring data back and dispatch a new action (success or fail)

import { Injectable } from "@angular/core";
// Actions is an observable that listens to the types of actions
// being dispatched and we can respond accordingly
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AssignmentsService } from "@carnegie-learning/data-access-angular-passport";
import * as courseMetricsActions from "../actions/course-metrics.action";

@Injectable()
export class CourseMetricsEffects {
    constructor(
        private actions$: Actions,
        private assignmentsService: AssignmentsService
    ) {}

    loadCourseMetrics$ = createEffect(() =>
        this.actions$.pipe(ofType(courseMetricsActions.loadCourseMetrics)).pipe(
            map((action) => action),
            switchMap(data => {
                return this.assignmentsService
                    .getStudentMetrics(data.courseID, data.studentID)
                    .pipe(
                        // mapping over all the To Do assignments and returning an action
                        map(
                            courseMetrics =>
                                courseMetricsActions.loadCourseMetricsSuccess(
                                    {payload: courseMetrics}
                                )
                        ),
                        // need to wrap the error in 'of' so it becomes an observable action
                        catchError(error =>
                            of(
                                courseMetricsActions.loadCourseMetricsFail(
                                    error
                                )
                            )
                        )
                    );
            })
        )
    );
}
